// extracted by mini-css-extract-plugin
export default {"InfoBox":"_InfoBox--Fnu81","InfoBoxTitle":"_InfoBoxTitle--u2f4D","InfoMessage":"_InfoMessage--yuPmV","ExclamationCircle":"_ExclamationCircle--oDfZY"};